module.exports = __webpack_public_path__ + "static/media/mail.8290f011.svg";